import type { UserPayloadDto } from "@/lib/lutely-api/gen/dtos";

// Fails closed: anything short of an explicit `true` gates the app. The server
// falls back to Cognito when the ID token claim isn't usable, so `undefined`
// here means we genuinely could not establish the account as verified.
export function userRequiresEmailVerification(
  user: UserPayloadDto | undefined,
): boolean {
  if (!user) return false;
  return user.emailVerified !== true;
}
